<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18.85" height="16.9" viewBox="0 0 18.85 16.9">
  <defs>
    <clipPath id="clip-path">
      <rect id="Rettangolo_12107" data-name="Rettangolo 12107" width="18.85" height="16.9" transform="translate(0 0)" fill="#3b3b3b"/>
    </clipPath>
  </defs>
  <g id="Raggruppa_15317" data-name="Raggruppa 15317" transform="translate(0 0)">
    <g id="Raggruppa_15316" data-name="Raggruppa 15316" clip-path="url(#clip-path)">
      <path id="Tracciato_11098" data-name="Tracciato 11098" d="M7.8,15.6a1.3,1.3,0,1,1-1.3-1.3,1.3,1.3,0,0,1,1.3,1.3m7.15-1.3a1.3,1.3,0,1,0,1.3,1.3,1.3,1.3,0,0,0-1.3-1.3M18.826,4.074l-2.083,7.5A1.957,1.957,0,0,1,14.868,13H6.838a1.954,1.954,0,0,1-1.882-1.428L2.106,1.3H.65A.65.65,0,0,1,.65,0H2.6a.65.65,0,0,1,.626.476L4,3.25H18.2a.65.65,0,0,1,.65.65.641.641,0,0,1-.024.174m-1.482.476H4.358l1.853,6.674a.65.65,0,0,0,.627.476h8.03a.651.651,0,0,0,.627-.476Z" fill="#3b3b3b"/>
    </g>
  </g>
</svg>
